// extracted by mini-css-extract-plugin
export var wrapper = "About-module--wrapper--20ZQy";
export var container = "About-module--container--fn7K-";
export var text = "About-module--text--3lp7n";
export var preBlockquote = "About-module--preBlockquote--156wv";
export var blockquote = "About-module--blockquote--37ZNk";
export var postBlockquote = "About-module--postBlockquote--7c6Sf";
export var image1 = "About-module--image1--2sSs_";
export var image0Container = "About-module--image0Container--1L5IR";
export var image1Container = "About-module--image1Container--12v2V";